import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import ThemeMenu from "ThemeMenu";
import { IMAGE_PATH, commonContainerWidth } from "Constants";

// import TemplatesDashboard from 'TemplatesDashboard';
// import TemplatesTheme from 'TemplatesTheme';
// import TemplatesSetting from 'TemplatesSetting';
import TemplatesWizard from "./components/wizard";
import TemplatesDomains from "./components/domains";
import TemplatesUpgrade from "./components/upgrade";
import TemplatesTheme from "./components/themes";
import TemplatesDashboard from "./dashboard";

import Pages from "./components/pages";
import Dashboard from "./components/dashboard";
import Menu from "./components/menu";
// import Seo from "./components/seo";
import Settings from "./components/settings";

class Templates extends Component {
  constructor(props) {
    super(props);
  }

  renderTemplatesOptionList() {
    return this.props.templatesMenus.map((item, index) => {
      if (item) {
        return <ThemeMenu key={item.iconName} item={item} />;
      }
    });
  }

  render() {
    return (
      <div className="content-parent-container">
        <div className="content-submenu vertical-line">
          <ul className="list-group">{this.renderTemplatesOptionList()}</ul>
        </div>
        <div
          className="content-subcontainer"
          // style={{ width: `${commonContainerWidth}px` }}
        >
          {/* <Route path="/dashboard/website/dashboard" component={TemplatesDashboard} /> */}
          {/* <Route path="/dashboard/website/themes" component={TemplatesTheme} /> */}
          {/* <Route path="/dashboard/website/settings" component={TemplatesSetting} /> */}

          {/* New Modules */}
          {/* <Route path="/dashboard/website/wizard" component={TemplatesWizard} />
                <Route path="/dashboard/website/dashboard" component={TemplatesDashboard} />
                <Route path="/dashboard/website/domains" component={TemplatesDomains} />
                <Route path="/dashboard/website/themes" component={TemplatesTheme} />
                <Route path="/dashboard/website/upgrade" component={TemplatesUpgrade} /> */}

          {/* New Modules 09/03/21*/}
          <Route
            path="/dashboard/website/dashboard"
            component={TemplatesDashboard}
          />
          <Route
            path="/dashboard/website/dashboard"
            // component={TemplatesDashboard}
          />
          <Route path="/dashboard/website/pages" component={Pages} />
          <Route path="/dashboard/website/menu" component={Menu} />
          {/* <Route path="/dashboard/website/seo" component={Seo} /> */}
          <Route path="/dashboard/website/settings" component={Settings} />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    templatesMenus: state.templatesMenus,
    session: state.session,
  };
}

export default connect(mapStateToProps)(Templates);
